













































































































































































































































































































































import { Component } from 'vue-property-decorator';
import UrlMixin from '@/components/query/url-mixin';
import { mixins } from 'vue-class-component';

import { CardForm } from '@/components/bwaff';
import MainMenu from './main-menu.vue';
import SettingsMenu from './settings-menu.vue';
import NavbarPayment from './navigation/navbar-payment.vue';
import NavbarSupport from './navigation/navbar-support.vue';
import ReportTabs from '@/views/reports/views/report-tabs.vue';
import IntercomMixin from '@/components/helpers/intercom-mixin';
import BookmarkList from '@/components/bookmark/bookmark-list.vue';
import NavbarWorkspaces from '@/views/layout/navigation/navbar-workspaces.vue';
import NavbarEvents from '@/views/layout/navigation/navbar-events.vue';
import NavbarBoostView from '@/views/layout/navigation/navbar-boost-view.vue';
import MenuEventsMixin from '@/views/layout/navigation/mixins/menu-events-mixin';
import NavbarEventsMenu from '@/views/layout/navigation/navbar-events-menu.vue';

@Component({
  components: {
    NavbarEventsMenu,
    NavbarWorkspaces,
    NavbarEvents,
    NavbarBoostView,
    MainMenu,
    SettingsMenu,
    CardForm,
    ReportTabs,
    NavbarPayment,
    NavbarSupport,
    BookmarkList
  }
})

export default class Navbar extends mixins(UrlMixin, IntercomMixin,MenuEventsMixin) {
  menu: boolean = false;

  get $FFReportingBoostViewEnabled() {
    return this.$FF?.reportingBoostView?.enabled;
  }

  get actions() {
    return {
      settings: {
        title:  this.t('Settings'),
        iconAppend: 'fas fa-cog',
        href: '/app/profile',
        routerLink: true
      },
      support: {
        title:  this.t('Support'),
        iconAppend: 'fas fa-question-circle'
      },
      workspaces: {
        title:  this.t('Workspaces'),
        iconAppend: 'fas fa-window-restore'
      },
      payment: {
        title:  this.t('Payment'),
        iconAppend: 'fas fa-exclamation-circle'
      },
      bookmarks: {
        title:  this.t('Bookmarks'),
        iconAppend: 'fas fa-star'
      },
      events: {
        title:  this.t('Events'),
        iconAppend: 'fas fa-gauge',
        color: this.isNavbarEventsRed && this.$colors.red,
        iconAppendColor: this.isNavbarEventsRed && this.$colors.red
      },
      boostView: {
        title:  this.t('Boost View'),
        iconAppend: 'fas fa-rocket',
      },
      logout: {
        title:  this.t('Logout'),
        iconAppend: 'fas fa-sign-out-alt',
        href: '/logout',
        routerLink: true
      }
    }
  }

  get menuList() {
    return [
      this.actions.logout
    ];
  }

  get route() {
    return this.$route.name || '';
  }

  get path() {
    return this.$route.path || '';
  }

  get showSelectedWorkspacesCount() {
    const {selectedWorkspaces, workspaces} = this.$store.state.user;
    const selectedWorkspacesLength = selectedWorkspaces && selectedWorkspaces.length
    return (selectedWorkspaces && selectedWorkspaces.length>0)
    && (workspaces && workspaces.length !==selectedWorkspacesLength)
  }

  mounted() {
    if(process.env.VUE_APP_MODE!=='cypress') {
      // @ts-ignore
      Intercom('onShow', () => {
        this.$store.commit('tabChatVis', true)
      });
    }
    // @ts-ignore
    // this.$intro().start();

    //show loader before any components start mounting
  }

  closeMenu() {
    this.menu = false;
  }

  handleLogout() {
    this.closeLiveSupport();
    this.closeMenu();
  }
  
  temporaryPassword() {
    this.$nextTick(()=>{
      this.bus.emit('open-dialog', { name: 'TemporaryPasswordDialog' });
    });
  }
}
